'use strict';

var Core = require('./Core');
module.exports = Core;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/uppy/lib/core/index.js
// module id = 175
// module chunks = 0